<template>
  <div class="table-content">
    <div class="table-wrap">
      <div class="qaqc-scorecard-summary-bar" v-if="summary">
        <div class="qaqc-scorecard-summary-card qaqc-scorecard-summary-overall qaqc-scorecard-summary-overall-passed">
          <!-- <div class="qaqc-scorecard-summary-icon-wrap">
            <v-img :src="icons['score']" contain class="qaqc-scorecard-summary-icon-img" />
          </div> -->
          <span class="qaqc-scorecard-summary-label">Overall Pass Rate</span>
          <span class="qaqc-scorecard-summary-value qaqc-scorecard-summary-value-orange">{{ summary.overallPassRate }}</span>
        </div>
        <div class="qaqc-scorecard-summary-card qaqc-scorecard-summary-passed qaqc-scorecard-summary-passed-passed">
          <!-- <div class="qaqc-scorecard-summary-icon-wrap">
            <v-img :src="icons['passed']" contain class="qaqc-scorecard-summary-icon-img" />
          </div> -->
          <span class="qaqc-scorecard-summary-label">Passed QC</span>
          <span class="qaqc-scorecard-summary-value">{{ summary.passedQc }}</span>
        </div>
        <div class="qaqc-scorecard-summary-card qaqc-scorecard-summary-pending qaqc-scorecard-summary-pending-pending">
          <!-- <div class="qaqc-scorecard-summary-icon-wrap">
            <v-img :src="icons['pending']" contain class="qaqc-scorecard-summary-icon-img" />
          </div> -->
          <span class="qaqc-scorecard-summary-label">Pending QC</span>
          <span class="qaqc-scorecard-summary-value">{{ summary.pendingQc }}</span>
        </div>
        <div class="qaqc-scorecard-summary-card qaqc-scorecard-summary-failed qaqc-scorecard-summary-failed-failed">
          <!-- <div class="qaqc-scorecard-summary-icon-wrap">
            <v-img :src="icons['failed']" contain class="qaqc-scorecard-summary-icon-img" />
          </div> -->
          <span class="qaqc-scorecard-summary-label">Failed</span>
          <span class="qaqc-scorecard-summary-value">{{ summary.failed }}</span>
        </div>
      </div>
      <div class="table-title-div">
        <p class="table-title">Data Quality Scorecard - {{ datasetLabel }}</p>
        <div class="qaqc-scorecard-header-actions">
          <div class="csv-btn" @click="downloadTableCSV">
            <v-img class="pointer" :src="documentDownload" alt="csv download"></v-img>
          </div>
          <v-btn
            icon
            variant="text"
            size="medium"
            class="qaqc-scorecard-collapse-btn"
            :aria-label="isCollapsed ? 'Expand' : 'Collapse'"
            @click="isCollapsed = !isCollapsed"
          >
            <v-icon>{{ isCollapsed ? 'mdi-chevron-down' : 'mdi-chevron-up' }}</v-icon>
          </v-btn>
        </div>
      </div>
      <div v-show="!isCollapsed" class="qaqc-table-content">
      <v-table class="test-data-table qaqc-table-wrap qaqc-scorecard-data-table fd-table">
        <thead>
          <tr class="main-header">
            <th class="sticky-header-sub search-dropdown-menu text-left qaqc-scorecard-col-well" :class="{ 'is-filter-open': searchDropdowns.well }">
              <v-menu
                v-model="searchDropdowns.well"
                attach="body"
                :close-on-content-click="false"
                location="bottom"
                transition="scale-transition"
              >
                <template v-slot:activator="{ props: menuActivatorProps }">
                  <span v-bind="menuActivatorProps" id="menu-activator-well" />
                </template>
                <v-list class="qaqc-scorecard-search-list">
                  <v-text-field variant="solo" class="search-table" v-model="searchQuery.well" label="Search wells" single-line hide-details @click.stop>
                    <template v-slot:prepend>
                      <v-img :src="magnify_black" class="ml-2" width="20" height="20"></v-img>
                    </template>
                  </v-text-field>
                  <v-list-item v-for="option in getFilteredOptions('well')" :key="'w-' + option" class="list-items qaqc-scorecard-filter-item" @click.stop>
                    <div class="data-list-content">
                      <input type="checkbox" :checked="isOptionSelected('well', option)" @change="toggleSelection('well', option)" @click.stop class="custom-checkbox" />
                      <span class="option-text">{{ option }}</span>
                    </div>
                  </v-list-item>
                  <v-list-item v-if="getFilteredOptions('well').length === 0" disabled>
                    <v-list-item-title class="fd-qaqc-column-filter-empty">No data found</v-list-item-title>
                  </v-list-item>
                  <v-list-item v-if="getSelectedOptions('well').length > 0" class="qaqc-scorecard-filter-item" @click.stop="clearColumnFilters('well')">
                    <v-list-item-title class="fd-qaqc-column-filter-clear">Clear Filters ({{ getSelectedOptions('well').length }})</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
              <div class="d-flex align-center justify-space-between">
                <div class="sort-icon-title d-flex align-center fd-qaqc-sort-title">
                  <div class="sort-icons">
                    <div class="img-div">
                      <img :src="sort_up" alt="sort-up" class="cursor-pointer" @click="sortColumn('well', 'asc')" />
                    </div>
                    <div class="img-div">
                      <img :src="sort_down" alt="sort-down" class="cursor-pointer" @click="sortColumn('well', 'desc')" />
                    </div>
                  </div>
                  Well
                </div>
                <div v-if="searchDropdowns.well" class="close-icon" @click.stop="searchDropdowns.well = false">
                  <v-img :src="close_icon" alt="close-icon"></v-img>
                </div>
                <div v-else class="search-icon" @click.stop="toggleSearchDropdown('well')">
                  <v-img :src="magnify" alt="search-icon"></v-img>
                </div>
              </div>
            </th>
            <th class="sticky-header-sub search-dropdown-menu text-left qaqc-scorecard-col-report" :class="{ 'is-filter-open': searchDropdowns.reportNo }">
              <v-menu
                v-model="searchDropdowns.reportNo"
                attach="body"
                :close-on-content-click="false"
                location="bottom"
                transition="scale-transition"
              >
                <template v-slot:activator="{ props: menuActivatorProps }">
                  <span v-bind="menuActivatorProps" id="menu-activator-reportNo" />
                </template>
                <v-list class="qaqc-scorecard-search-list">
                  <v-text-field variant="solo" class="search-table" v-model="searchQuery.reportNo" label="Search report no." single-line hide-details @click.stop>
                    <template v-slot:prepend>
                      <v-img :src="magnify_black" class="ml-2" width="20" height="20"></v-img>
                    </template>
                  </v-text-field>
                  <v-list-item v-for="option in getFilteredOptions('reportNo')" :key="'rn-' + option" class="list-items qaqc-scorecard-filter-item" @click.stop>
                    <div class="data-list-content">
                      <input type="checkbox" :checked="isOptionSelected('reportNo', option)" @change="toggleSelection('reportNo', option)" @click.stop class="custom-checkbox" />
                      <span class="option-text">{{ option }}</span>
                    </div>
                  </v-list-item>
                  <v-list-item v-if="getFilteredOptions('reportNo').length === 0" disabled>
                    <v-list-item-title class="fd-qaqc-column-filter-empty">No data found</v-list-item-title>
                  </v-list-item>
                  <v-list-item v-if="getSelectedOptions('reportNo').length > 0" class="qaqc-scorecard-filter-item" @click.stop="clearColumnFilters('reportNo')">
                    <v-list-item-title class="fd-qaqc-column-filter-clear">Clear Filters ({{ getSelectedOptions('reportNo').length }})</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
              <div class="d-flex align-center justify-space-between">
                <div class="sort-icon-title d-flex align-center fd-qaqc-sort-title">
                  <div class="sort-icons">
                    <div class="img-div">
                      <img :src="sort_up" alt="sort-up" class="cursor-pointer" @click="sortColumn('reportNo', 'asc')" />
                    </div>
                    <div class="img-div">
                      <img :src="sort_down" alt="sort-down" class="cursor-pointer" @click="sortColumn('reportNo', 'desc')" />
                    </div>
                  </div>
                  Report No.
                </div>
                <div v-if="searchDropdowns.reportNo" class="close-icon" @click.stop="searchDropdowns.reportNo = false">
                  <v-img :src="close_icon" alt="close-icon"></v-img>
                </div>
                <div v-else class="search-icon" @click.stop="toggleSearchDropdown('reportNo')">
                  <v-img :src="magnify" alt="search-icon"></v-img>
                </div>
              </div>
            </th>
            <th class="sticky-header-sub search-dropdown-menu text-left qaqc-scorecard-col-pvt" :class="{ 'is-filter-open': searchDropdowns.sampleIds }">
              <v-menu
                v-model="searchDropdowns.sampleIds"
                attach="body"
                :close-on-content-click="false"
                location="bottom"
                transition="scale-transition"
              >
                <template v-slot:activator="{ props: menuActivatorProps }">
                  <span v-bind="menuActivatorProps" id="menu-activator-sampleIds" />
                </template>
                <v-list class="qaqc-scorecard-search-list">
                  <v-text-field variant="solo" class="search-table" v-model="searchQuery.sampleIds" label="Search sample ID" single-line hide-details @click.stop>
                    <template v-slot:prepend>
                      <v-img :src="magnify_black" class="ml-2" width="20" height="20"></v-img>
                    </template>
                  </v-text-field>
                  <v-list-item v-for="option in getFilteredOptions('sampleIds')" :key="'sid-' + option" class="list-items qaqc-scorecard-filter-item" @click.stop>
                    <div class="data-list-content">
                      <input type="checkbox" :checked="isOptionSelected('sampleIds', option)" @change="toggleSelection('sampleIds', option)" @click.stop class="custom-checkbox" />
                      <span class="option-text">{{ option }}</span>
                    </div>
                  </v-list-item>
                  <v-list-item v-if="getFilteredOptions('sampleIds').length === 0" disabled>
                    <v-list-item-title class="fd-qaqc-column-filter-empty">No data found</v-list-item-title>
                  </v-list-item>
                  <v-list-item v-if="getSelectedOptions('sampleIds').length > 0" class="qaqc-scorecard-filter-item" @click.stop="clearColumnFilters('sampleIds')">
                    <v-list-item-title class="fd-qaqc-column-filter-clear">Clear Filters ({{ getSelectedOptions('sampleIds').length }})</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
              <div class="d-flex align-center justify-space-between">
                <div class="sort-icon-title d-flex align-center fd-qaqc-sort-title">
                  <div class="sort-icons">
                    <div class="img-div">
                      <img :src="sort_up" alt="sort-up" class="cursor-pointer" @click="sortColumn('sampleIds', 'asc')" />
                    </div>
                    <div class="img-div">
                      <img :src="sort_down" alt="sort-down" class="cursor-pointer" @click="sortColumn('sampleIds', 'desc')" />
                    </div>
                  </div>
                  Samples with PVT Tests only
                </div>
                <div v-if="searchDropdowns.sampleIds" class="close-icon" @click.stop="searchDropdowns.sampleIds = false">
                  <v-img :src="close_icon" alt="close-icon"></v-img>
                </div>
                <div v-else class="search-icon" @click.stop="toggleSearchDropdown('sampleIds')">
                  <v-img :src="magnify" alt="search-icon"></v-img>
                </div>
              </div>
            </th>
            <th class="sticky-header-sub search-dropdown-menu text-left qaqc-scorecard-col-pass" :class="{ 'is-filter-open': searchDropdowns.passRate }">
              <v-menu
                v-model="searchDropdowns.passRate"
                attach="body"
                :close-on-content-click="false"
                location="bottom"
                transition="scale-transition"
              >
                <template v-slot:activator="{ props: menuActivatorProps }">
                  <span v-bind="menuActivatorProps" id="menu-activator-passRate" />
                </template>
                <v-list class="qaqc-scorecard-search-list">
                  <v-text-field variant="solo" class="search-table" v-model="searchQuery.passRate" label="Search pass rate" single-line hide-details @click.stop>
                    <template v-slot:prepend>
                      <v-img :src="magnify_black" class="ml-2" width="20" height="20"></v-img>
                    </template>
                  </v-text-field>
                  <v-list-item v-for="option in getFilteredOptions('passRate')" :key="'p-' + option" class="list-items qaqc-scorecard-filter-item" @click.stop>
                    <div class="data-list-content">
                      <input type="checkbox" :checked="isOptionSelected('passRate', option)" @change="toggleSelection('passRate', option)" @click.stop class="custom-checkbox" />
                      <span class="option-text">{{ option }}</span>
                    </div>
                  </v-list-item>
                  <v-list-item v-if="getFilteredOptions('passRate').length === 0" disabled>
                    <v-list-item-title class="fd-qaqc-column-filter-empty">No data found</v-list-item-title>
                  </v-list-item>
                  <v-list-item v-if="getSelectedOptions('passRate').length > 0" class="qaqc-scorecard-filter-item" @click.stop="clearColumnFilters('passRate')">
                    <v-list-item-title class="fd-qaqc-column-filter-clear">Clear Filters ({{ getSelectedOptions('passRate').length }})</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
              <div class="d-flex align-center justify-space-between">
                <div class="sort-icon-title d-flex align-center fd-qaqc-sort-title">
                  <div class="sort-icons">
                    <div class="img-div">
                      <img :src="sort_up" alt="sort-up" class="cursor-pointer" @click="sortColumn('passRate', 'asc')" />
                    </div>
                    <div class="img-div">
                      <img :src="sort_down" alt="sort-down" class="cursor-pointer" @click="sortColumn('passRate', 'desc')" />
                    </div>
                  </div>
                  <span class="qaqc-scorecard-col-title-with-note">
                    Pass Rate (%)
                  </span>
                </div>
                <div class="fd-table-header-actions">
                  <v-tooltip location="top" content-class="qaqc-test-info-tooltip qaqc-scorecard-column-info-tooltip">
                    <template v-slot:activator="{ props }">
                      <v-img
                        v-bind="props"
                        :src="infoIcon"
                        class="qaqc-test-info-icon qaqc-scorecard-header-note-icon"
                        width="16"
                        height="16"
                        alt=""
                        aria-label="Column description"
                      />
                    </template>
                    <div class="qaqc-test-tooltip-content">{{ passRateColumnTooltip }}</div>
                  </v-tooltip>
                  <div v-if="searchDropdowns.passRate" class="close-icon" @click.stop="searchDropdowns.passRate = false">
                    <v-img :src="close_icon" alt="close-icon"></v-img>
                  </div>
                  <div v-else class="search-icon" @click.stop="toggleSearchDropdown('passRate')">
                    <v-img :src="magnify" alt="search-icon"></v-img>
                  </div>
                </div>
              </div>
            </th>
            <th class="sticky-header-sub search-dropdown-menu text-left qaqc-scorecard-col-score" :class="{ 'is-filter-open': searchDropdowns.avgQualityScore }">
              <v-menu
                v-model="searchDropdowns.avgQualityScore"
                attach="body"
                :close-on-content-click="false"
                location="bottom"
                transition="scale-transition"
              >
                <template v-slot:activator="{ props: menuActivatorProps }">
                  <span v-bind="menuActivatorProps" id="menu-activator-avgQualityScore" />
                </template>
                <v-list class="qaqc-scorecard-search-list">
                  <v-text-field variant="solo" class="search-table" v-model="searchQuery.avgQualityScore" label="Search avg score" single-line hide-details @click.stop>
                    <template v-slot:prepend>
                      <v-img :src="magnify_black" class="ml-2" width="20" height="20"></v-img>
                    </template>
                  </v-text-field>
                  <v-list-item v-for="option in getFilteredOptions('avgQualityScore')" :key="'a-' + option" class="list-items qaqc-scorecard-filter-item" @click.stop>
                    <div class="data-list-content">
                      <input type="checkbox" :checked="isOptionSelected('avgQualityScore', option)" @change="toggleSelection('avgQualityScore', option)" @click.stop class="custom-checkbox" />
                      <span class="option-text">{{ option }}</span>
                    </div>
                  </v-list-item>
                  <v-list-item v-if="getFilteredOptions('avgQualityScore').length === 0" disabled>
                    <v-list-item-title class="fd-qaqc-column-filter-empty">No data found</v-list-item-title>
                  </v-list-item>
                  <v-list-item v-if="getSelectedOptions('avgQualityScore').length > 0" class="qaqc-scorecard-filter-item" @click.stop="clearColumnFilters('avgQualityScore')">
                    <v-list-item-title class="fd-qaqc-column-filter-clear">Clear Filters ({{ getSelectedOptions('avgQualityScore').length }})</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
              <div class="d-flex align-center justify-space-between">
                <div class="sort-icon-title d-flex align-center fd-qaqc-sort-title">
                  <div class="sort-icons">
                    <div class="img-div">
                      <img :src="sort_up" alt="sort-up" class="cursor-pointer" @click="sortColumn('avgQualityScore', 'asc')" />
                    </div>
                    <div class="img-div">
                      <img :src="sort_down" alt="sort-down" class="cursor-pointer" @click="sortColumn('avgQualityScore', 'desc')" />
                    </div>
                  </div>
                  <span class="qaqc-scorecard-col-title-with-note">
                    Average Quality Score
                  </span>
                </div>
                <div class="fd-table-header-actions">
                  <v-tooltip location="top" content-class="qaqc-test-info-tooltip qaqc-scorecard-column-info-tooltip">
                    <template v-slot:activator="{ props }">
                      <v-img
                        v-bind="props"
                        :src="infoIcon"
                        class="qaqc-test-info-icon qaqc-scorecard-header-note-icon"
                        width="16"
                        height="16"
                        alt=""
                        aria-label="Column description"
                      />
                    </template>
                    <div class="qaqc-test-tooltip-content">{{ avgQualityScoreColumnTooltip }}</div>
                  </v-tooltip>
                  <div v-if="searchDropdowns.avgQualityScore" class="close-icon" @click.stop="searchDropdowns.avgQualityScore = false">
                    <v-img :src="close_icon" alt="close-icon"></v-img>
                  </div>
                  <div v-else class="search-icon" @click.stop="toggleSearchDropdown('avgQualityScore')">
                    <v-img :src="magnify" alt="search-icon"></v-img>
                  </div>
                </div>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, idx) in paginatedRows" :key="row.well + '-' + idx">
            <td class="qaqc-scorecard-col-well" @click="navigateToWellDetail(row.well)">
              <span class="cursor-pointer clickable-cell well-cell no-bg">{{ row.well }}</span>
            </td>
            <td class="text-left qaqc-scorecard-reports-cell qaqc-scorecard-col-report" @click.stop>
              <div class="qaqc-scorecard-cell-chips">
                <template v-if="uniqueReports(row).length">
                  <button
                    v-for="rid in uniqueReports(row)"
                    :key="'r-' + row.well + '-' + rid"
                    type="button"
                    class="qaqc-report-chip"
                    @click="navigateToReportDetail(row.well, rid, row)"
                  >
                    {{ rid }}
                  </button>
                </template>
                <span v-else class="qaqc-scorecard-empty-dash">—</span>
              </div>
            </td>
            <td class="text-left qaqc-scorecard-samples-cell qaqc-scorecard-col-pvt" @click.stop>
              <div class="qaqc-scorecard-cell-chips">
                <span
                  v-for="(ent, si) in (row.sampleEntries || [])"
                  :key="'s-' + row.well + '-' + (ent.id || si) + '-' + si"
                  class="qaqc-sample-id-chip"
                  role="button"
                  tabindex="0"
                  @click="navigateToSampleDetail(row.well, ent)"
                  @keydown.enter.prevent="navigateToSampleDetail(row.well, ent)"
                >
                  {{ ent.fluidSampleID || "—" }}
                </span>
                <span v-if="!(row.sampleEntries && row.sampleEntries.length)" class="qaqc-scorecard-empty-dash">—</span>
              </div>
            </td>
            <td class="text-left qaqc-scorecard-col-pass">{{ getRowValue(row, 'passRate') }}</td>
            <td class="text-left qaqc-scorecard-col-score">{{ getRowValue(row, 'avgQualityScore') }}</td>
          </tr>
        </tbody>
      </v-table>
      <Pagination
        v-if="totalItems > 0"
        variant="scorecard"
        :total-items="totalItems"
        v-model:current-page="currentPage"
        v-model:items-per-page="itemsPerPage"
        item-label="Wells"
        :page-sizes="[10, 20, 50, 100]"
      />
      </div>
    </div>
  </div>
</template>

<script>
import { csvEscapeCell } from "./distributionCsvHelpers.js";
import {
  scorecardDatasetLabelToApiFilters,
  routerQueryFromApiFilters,
} from "./qaqcSamplesListQuery.js";
import Pagination from "../../Common/Pagination.vue";

const SCORECARD_FILTER_KEYS = ["well", "reportNo", "sampleIds", "passRate", "avgQualityScore"];

// Persists the wells-per-page selection across navigation (table remounts when
// returning from well/report/sample detail views).
const SCORECARD_PER_PAGE_STORAGE_KEY = "qaqcScorecardWellsPerPage";

function readStoredItemsPerPage() {
  try {
    const n = Number(sessionStorage.getItem(SCORECARD_PER_PAGE_STORAGE_KEY));
    return Number.isFinite(n) && n > 0 ? n : null;
  } catch (_) {
    return null;
  }
}

export default {
  name: "DataQualityScorecardTable",
  components: { Pagination },
  data() {
    return {
      icons: {
        score: require("@/assets/Svg/score.svg"),
        passed: require("@/assets/Svg/passed.svg"),
        pending: require("@/assets/Svg/pending.svg"),
        failed: require("@/assets/Svg/failed.svg"),
      },
      magnify: require("@/assets/Svg/Icons/search.svg"),
      magnify_black: require("@/assets/Svg/Icons/search.svg"),
      sort_up: require("@/assets/Svg/Table/up.svg"),
      sort_down: require("@/assets/Svg/Table/down.svg"),
      close_icon: require("@/assets/Svg/Icons/cross-circle.svg"),
      searchDropdowns: {
        well: false,
        reportNo: false,
        sampleIds: false,
        passRate: false,
        avgQualityScore: false,
      },
      searchQuery: {
        well: "",
        reportNo: "",
        sampleIds: "",
        passRate: "",
        avgQualityScore: "",
      },
      selectedFilters: {
        well: [],
        reportNo: [],
        sampleIds: [],
        passRate: [],
        avgQualityScore: [],
      },
      currentSortColumn: "",
      sortDirection: "asc",
      itemsPerPage: readStoredItemsPerPage() || 10,
      currentPage: 1,
      isCollapsed: false,
      documentDownload: require("@/assets/Images/csv.svg"),
      infoIcon: require("@/assets/Svg/infoIcon.svg"),
    };
  },
  props: {
    rows: { type: Array, default: () => [] },
    summary: {
      type: Object,
      default: () => ({
        overallPassRate: "0%",
        passedQc: 0,
        pendingQc: 0,
        failed: 0,
      }),
    },
    datasetLabel: { type: String, default: "CCE Dataset" },
    groupBy: {
      type: String,
      default: "well",
      validator: (v) => v === "well" || v === "report",
    },
  },
  computed: {
    explodedRows() {
      if (this.groupBy !== "report") return this.rows || [];
      const out = [];
      (this.rows || []).forEach((row) => {
        const byReport = new Map();
        (row?.sampleEntries || []).forEach((e) => {
          const rid =
            e.reportIdentifier != null && String(e.reportIdentifier).trim() !== ""
              ? String(e.reportIdentifier)
              : null;
          if (!rid) return;
          if (!byReport.has(rid)) byReport.set(rid, []);
          byReport.get(rid).push(e);
        });
        byReport.forEach((groupEntries) => {
          out.push({
            well: row.well,
            sampleEntries: groupEntries,
            passRate: row.passRate,
            avgQualityScore: row.avgQualityScore,
          });
        });
      });
      return out;
    },
    filteredRows() {
      let list = [...this.explodedRows];
      if (this.selectedFilters.well.length > 0) {
        list = list.filter((row) => this.selectedFilters.well.includes(this.getRowValue(row, "well")));
      }
      if (this.selectedFilters.reportNo.length > 0) {
        list = list.filter((row) => {
          const reps = this.uniqueReports(row);
          return reps.some((r) => this.selectedFilters.reportNo.includes(r));
        });
      }
      if (this.selectedFilters.sampleIds.length > 0) {
        list = list.filter((row) => {
          const ids = this.fluidSampleIdsForRow(row);
          return ids.some((id) => this.selectedFilters.sampleIds.includes(id));
        });
      }
      if (this.selectedFilters.passRate.length > 0) {
        list = list.filter((row) => this.selectedFilters.passRate.includes(this.getRowValue(row, "passRate")));
      }
      if (this.selectedFilters.avgQualityScore.length > 0) {
        list = list.filter((row) =>
          this.selectedFilters.avgQualityScore.includes(this.getRowValue(row, "avgQualityScore"))
        );
      }
      if (this.currentSortColumn) {
        list.sort((a, b) => {
          const cmp = this.compareSortValues(a, b, this.currentSortColumn);
          return this.sortDirection === "asc" ? cmp : -cmp;
        });
      }
      return list;
    },
    totalItems() {
      return this.filteredRows.length;
    },
    startIndex() {
      return (this.currentPage - 1) * this.itemsPerPage;
    },
    endIndex() {
      return Math.min(this.startIndex + this.itemsPerPage, this.totalItems);
    },
    paginatedRows() {
      const list = this.filteredRows;
      return list.slice(this.startIndex, this.endIndex);
    },
    totalPages() {
      if (this.itemsPerPage <= 0) return 1;
      return Math.ceil(this.totalItems / this.itemsPerPage) || 1;
    },
    scorecardNotesKey() {
      const label = (this.datasetLabel || "").trim();
      const lower = label.toLowerCase();
      if (label === "DL Dataset" || lower === "dl dataset") return "dl";
      if (label === "Separator Dataset" || lower.includes("separator")) return "separator";
      if (label === "CCE Dataset (Gas)" || lower.includes("(gas)")) return "cceGas";
      if (label === "CCE Dataset (Oil)" || lower.includes("(oil)")) return "cceOil";
      return "cceOil";
    },
    passRateColumnTooltip() {
      const notes = {
        cceOil:
          "Aggregate pass rate (%) of oil Constant Composition Expansion (CCE) tests for a specific well.",
        cceGas:
          "Aggregate pass rate (%) of gas Constant Composition Expansion (CCE) tests for a specific well.",
        dl: "Aggregate pass rate (%) of Differential Liberation (DL) tests for a specific well.",
        separator:
          "Aggregate pass rate (%) of Separator tests for a specific well.",
      };
      return notes[this.scorecardNotesKey] || notes.cceOil;
    },
    avgQualityScoreColumnTooltip() {
      const notes = {
        cceOil:
          "The average quality score represents the mean value obtained across all predefined evaluation criteria used to assess the quality of Constant Composition Expansion (CCE) oil data. Each CCE oil test is evaluated against multiple quality criteria, with an individual score assigned to each criterion. The overall average quality score is calculated as the arithmetic mean of these individual scores. This metric serves as a single aggregated indicator of the overall quality of the CCE oil dataset.",
        cceGas:
          "The average quality score represents the mean value obtained across all predefined evaluation criteria used to assess the quality of Constant Composition Expansion (CCE) gas data. Each CCE gas test is evaluated against multiple quality criteria, with an individual score assigned to each criterion. The overall average quality score is calculated as the arithmetic mean of these individual scores. This metric serves as a single aggregated indicator of the overall quality of the CCE gas dataset.",
        dl:
          "The average quality score represents the mean value obtained across all predefined evaluation criteria used to assess the quality of Differential Liberation (DL) data. Each DL test is evaluated against multiple quality criteria, with an individual score assigned to each criterion. The overall average quality score is calculated as the arithmetic mean of these individual scores. This metric serves as a single aggregated indicator of the overall quality of the DL dataset.",
        separator:
          "The average quality score represents the mean value obtained across all predefined evaluation criteria used to assess the quality of Separator Test data. Each Separator test is evaluated against multiple quality criteria, with an individual score assigned to each criterion. The overall average quality score is calculated as the arithmetic mean of these individual scores. This metric serves as a single aggregated indicator of the overall quality of the Separator dataset.",
      };
      return notes[this.scorecardNotesKey] || notes.cceOil;
    },
  },
  watch: {
    rows() {
      this.currentPage = 1;
      this.resetColumnFilters();
    },
    groupBy() {
      this.currentPage = 1;
      this.resetColumnFilters();
    },
    itemsPerPage(value) {
      try {
        sessionStorage.setItem(SCORECARD_PER_PAGE_STORAGE_KEY, String(value));
      } catch (_) {}
      this.currentPage = 1;
    },
    selectedFilters: {
      handler() {
        this.currentPage = 1;
      },
      deep: true,
    },
  },
  methods: {
    formatNumericTwoDecimals(value) {
      if (value === null || value === undefined) return "";
      const s = String(value).trim();
      if (s === "" || s === "-") return s;
      const hasPercent = s.includes("%");
      const n = parseFloat(s.replace(/%/g, "").replace(/,/g, "").trim());
      if (!Number.isFinite(n)) return String(value);
      const rounded = (Math.round(n * 100) / 100).toFixed(2);
      return hasPercent ? `${rounded}%` : rounded;
    },
    getRowValue(row, column) {
      if (!row) return "";
      if (column === "reportNo") {
        const reps = this.uniqueReports(row);
        if (reps.length === 0) return "";
        return reps
          .slice()
          .sort((a, b) => a.localeCompare(b, undefined, { numeric: true }))
          .join(", ");
      }
      if (column === "sampleIds") {
        const ids = this.fluidSampleIdsForRow(row);
        if (ids.length === 0) return "";
        return ids
          .slice()
          .sort((a, b) => a.localeCompare(b, undefined, { numeric: true }))
          .join(", ");
      }
      const v = row[column];
      if (v === null || v === undefined) return "";
      if (column === "passRate" || column === "avgQualityScore") {
        return this.formatNumericTwoDecimals(v);
      }
      return String(v);
    },
    uniqueReports(row) {
      const set = new Set();
      (row?.sampleEntries || []).forEach((e) => {
        if (e.reportIdentifier != null && String(e.reportIdentifier).trim() !== "") {
          set.add(String(e.reportIdentifier));
        }
      });
      return [...set];
    },
    fluidSampleIdsForRow(row) {
      const set = new Set();
      (row?.sampleEntries || []).forEach((e) => {
        if (e.fluidSampleID != null && String(e.fluidSampleID).trim() !== "") {
          set.add(String(e.fluidSampleID));
        }
      });
      return [...set];
    },
    getFilteredOptions(column) {
      const list = this.explodedRows || [];
      let rawValues = [];
      if (column === "reportNo") {
        const set = new Set();
        list.forEach((row) => {
          this.uniqueReports(row).forEach((r) => set.add(r));
        });
        rawValues = [...set];
      } else if (column === "sampleIds") {
        const set = new Set();
        list.forEach((row) => {
          this.fluidSampleIdsForRow(row).forEach((id) => set.add(id));
        });
        rawValues = [...set];
      } else {
        rawValues = list.map((row) => this.getRowValue(row, column));
      }
      const uniqueValues = [...new Set(rawValues)].filter((value) => value !== "");
      const query = (this.searchQuery[column] || "").toLowerCase();
      return uniqueValues.filter((value) => value.toLowerCase().includes(query));
    },
    isOptionSelected(column, option) {
      return this.selectedFilters[column].includes(option);
    },
    toggleSelection(column, option) {
      const prev = this.selectedFilters[column] || [];
      const index = prev.indexOf(option);
      const next = index > -1 ? prev.filter((_, i) => i !== index) : [...prev, option];
      this.selectedFilters = { ...this.selectedFilters, [column]: next };
    },
    getSelectedOptions(column) {
      return this.selectedFilters[column];
    },
    clearColumnFilters(column) {
      this.selectedFilters = { ...this.selectedFilters, [column]: [] };
      this.searchQuery = { ...this.searchQuery, [column]: "" };
    },
    resetColumnFilters() {
      const nextSel = { ...this.selectedFilters };
      const nextQ = { ...this.searchQuery };
      SCORECARD_FILTER_KEYS.forEach((key) => {
        nextSel[key] = [];
        nextQ[key] = "";
      });
      this.selectedFilters = nextSel;
      this.searchQuery = nextQ;
      this.currentSortColumn = "";
      this.sortDirection = "asc";
    },
    sortColumn(column, direction) {
      this.currentSortColumn = column;
      this.sortDirection = direction;
    },
    toggleSearchDropdown(key) {
      this.searchDropdowns[key] = !this.searchDropdowns[key];
    },
    compareSortValues(a, b, column) {
      const va = this.getRowValue(a, column);
      const vb = this.getRowValue(b, column);
      if (column === "well" || column === "reportNo" || column === "sampleIds") {
        return va.localeCompare(vb, undefined, { numeric: true, sensitivity: "base" });
      }
      const na = this.parseNumericSort(va);
      const nb = this.parseNumericSort(vb);
      if (na !== null && nb !== null) {
        return na - nb;
      }
      return va.localeCompare(vb, undefined, { numeric: true });
    },
    parseNumericSort(s) {
      if (s === "" || s === "-") return null;
      const n = parseFloat(String(s).replace(/%/g, "").trim());
      return Number.isFinite(n) ? n : null;
    },
    scorecardSamplesListQuery() {
      return {
        type: "wells",
        ...routerQueryFromApiFilters(scorecardDatasetLabelToApiFilters(this.datasetLabel)),
      };
    },
    navigateToWellDetail(wellName) {
      if (wellName == null || wellName === "" || wellName === "-") return;
      this.$router.push({
        name: "QAQCDetailView",
        params: { well: String(wellName) },
        query: this.scorecardSamplesListQuery(),
      });
    },
    navigateToReportDetail(wellName, reportIdentifier, row) {
      if (
        wellName == null ||
        wellName === "" ||
        wellName === "-" ||
        reportIdentifier == null ||
        String(reportIdentifier).trim() === ""
      ) {
        return;
      }
      const entries = row?.sampleEntries || [];
      const match = entries.find(
        (e) => e.reportIdentifier != null && String(e.reportIdentifier) === String(reportIdentifier)
      );
      const sampleMongoId = match?.id || entries[0]?.id;
      if (!sampleMongoId) {
        return;
      }
      this.$router.push({
        name: "QAQCDetailReport",
        params: {
          well: String(wellName),
          sampleId: String(sampleMongoId),
          reportIdentifier: String(reportIdentifier),
        },
        query: this.scorecardSamplesListQuery(),
      });
    },
    navigateToSampleDetail(wellName, ent) {
      if (wellName == null || wellName === "" || wellName === "-" || !ent || !ent.id) return;
      this.$router.push({
        name: "QAQCDetailSample",
        params: {
          well: String(wellName),
          sampleId: String(ent.id),
          fluidSampleID: String(ent.fluidSampleID ?? ""),
        },
        query: this.scorecardSamplesListQuery(),
      });
    },
    downloadTableCSV() {
      const rows = this.filteredRows;
      if (!rows || rows.length === 0) {
        return;
      }
      const safeLabel = (this.datasetLabel || "dataset").replace(/[^a-z0-9-_]/gi, "_").toLowerCase();
      const fileName = `data_quality_scorecard_${safeLabel}.csv`;
      const csvHeader = ["Well", "Report No.", "Sample ID", "Pass Rate", "Average Quality Score"];
      const csvRows = rows.map((row) =>
        [
          csvEscapeCell(this.getRowValue(row, "well")),
          csvEscapeCell(this.getRowValue(row, "reportNo") || "—"),
          csvEscapeCell(this.getRowValue(row, "sampleIds") || "—"),
          csvEscapeCell(this.getRowValue(row, "passRate")),
          csvEscapeCell(this.getRowValue(row, "avgQualityScore")),
        ].join(",")
      );
      const csvContent =
        "\ufeff" +
        [csvHeader.map(csvEscapeCell).join(","), ...csvRows].join("\n");
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      if (link.download !== undefined) {
        const url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      }
    },
  },
};
</script>
